module.exports = __webpack_public_path__ + "static/media/wes_brands_x_miami_22.c30fc8d0.png";